/**
 * 
 * Left.js
 * 
 */

import React, { Component } from 'react'
import { Container } from 'react-bootstrap';
 
 export default class Left extends Component {

    static displayName = Left.name;

     render() {


         return (

             <Container style={{ backgroundColor: '', paddingTop: '80px' }}>
                <span style={{ padding: '30px', paddingLeft: '20px', paddingTop: '100px', fontSize: '45px' }}>
                    Our Solution
                </span>

                <p style={{ padding: '20px', paddingBottom: '0px', fontSize: '20px', fontWeight: 'lighter', textAlign: 'left' }}>
                    Smile is a mobile payment app and a platform that hosts third-party apps for businesses in Ethiopia. 
                </p>

                <p style={{ padding: '20px', paddingBottom: '0px', fontSize: '20px', fontWeight: 'lighter', textAlign: 'left' }}>
                    Smile app allows individuals and businesses to send and accept payment online or offline. It also offers an opportunity for companies to build and host their apps within the Smile app in the form of mini-programs or Telegram bots fast and cheap. 
                </p>


             </Container>

         );


     }


 }
 
 